"use strict";

var ActiveDescendant = _interopRequireWildcard(require("makeup-active-descendant"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
//const ActiveDescendant = require('makeup-active-descendant');

// IMPORT

const navs = [];
const append = document.getElementById("append");
const prepend = document.getElementById("prepend");
const removeFirst = document.getElementById("removeFirst");
const removeLast = document.getElementById("removeLast");
const widgetEls = document.querySelectorAll(".widget");
const wrapCheckbox = document.getElementById("wrap");
const log = e => console.log(e.type, e.detail);
prepend.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const list = el.querySelector("ul");
    const newListItem = document.createElement("li");
    newListItem.setAttribute("role", "option");
    const numListItems = parseInt(list.querySelectorAll("li").length, 10);
    newListItem.innerText = `Item ${numListItems + 1}`;
    list.insertBefore(newListItem, list.children[0]);
  });
});
append.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const list = el.querySelector("ul");
    const newListItem = document.createElement("li");
    newListItem.setAttribute("role", "option");
    const numListItems = parseInt(list.querySelectorAll("li").length, 10);
    newListItem.innerText = `Item ${numListItems + 1}`;
    list.appendChild(newListItem);
  });
});
removeFirst.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const list = el.querySelector("ul");
    const node = list.firstElementChild;
    list.removeChild(node);
  });
});
removeLast.addEventListener("click", function () {
  widgetEls.forEach(function (el) {
    const list = el.querySelector("ul");
    const node = list.lastElementChild;
    list.removeChild(node);
  });
});
disableCurrent.addEventListener("click", function () {
  navs.forEach(function (nav) {
    if (nav.currentItem) nav.currentItem.setAttribute("aria-disabled", "true");
  });
});
widgetEls.forEach(function (el) {
  el.addEventListener("activeDescendantInit", log);
  el.addEventListener("activeDescendantChange", log);
  el.addEventListener("activeDescendantReset", log);
  el.addEventListener("activeDescendantMutation", log);
  const widget = ActiveDescendant.createLinear(el, el.querySelector("input") || el.querySelector("ul"), el.querySelector("ul"), "li", {
    nonEmittingElementSelector: 'input[type="button"]'
  });
  navs.push(widget);
});
wrapCheckbox.addEventListener("change", function (e) {
  navs.forEach(function (nav) {
    nav.wrap = e.target.checked;
  });
});